var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PCNavbar',{attrs:{"selectIndex":"1","isBlue":"true"}}),_c('MobileNavBar',{attrs:{"currentActive":0}}),_c('NewsDetailsMobile',{attrs:{"content":_vm.newsContent,"newDet":_vm.newDet}}),_c('MobileCallme')],1)}
var staticRenderFns = []

export { render, staticRenderFns }